import { isPast } from 'date-fns';

import { useConfigContext } from '#src/contexts/config/index.ts';

type WheelConfigWithEndDate = {
  ticketDistributionEndDate: Date;
} | null;

const isDistributionEnded = (config: WheelConfigWithEndDate) =>
  !!config && isPast(config.ticketDistributionEndDate);

export const useWheelTicketDistributionEndedByRarity = () => {
  const { wheel } = useConfigContext();

  return {
    // Common wheels never have an ended ticket distribution.
    common: false,
    limited: isDistributionEnded(wheel.limitedWheelConfig),
    rare: isDistributionEnded(wheel.rareWheelConfig),
    super_rare: isDistributionEnded(wheel.superRareWheelConfig),
    unique: isDistributionEnded(wheel.uniqueWheelConfig),
  };
};
